import { isAppRoute, lessonIdFromPath } from '../shared/routes';
import { RequireTeacher } from './components/AppShell';
import { ForgotPassword, ResetPassword, VerifyEmail } from './pages/AccountPages';
import { Admin } from './pages/Admin';
import { Home } from './pages/Home';
import { Legal, type LegalKind } from './pages/Legal';
import { LessonPage } from './pages/LessonPage';
import { Login } from './pages/Login';
import { NotFound } from './pages/NotFound';
import { Register } from './pages/Register';
import { LessonDetailPage, LessonsPage, ProfilePage, StudentsPage } from './pages/TeacherPages';

export function App() {
  const path = window.location.pathname;
  if (!isAppRoute(path)) return <NotFound />;
  const lessonId = lessonIdFromPath(path);
  if (lessonId) {
    const teacherKey = new URLSearchParams(window.location.search).get('ogretmen') ?? undefined;
    return <LessonPage lessonId={lessonId} teacherKey={teacherKey} />;
  }
  const detail = /^\/derslerim\/([a-z0-9]{4,20})\/?$/.exec(path);
  if (detail) return <RequireTeacher>{(me) => <LessonDetailPage me={me} id={detail[1]} />}</RequireTeacher>;
  if (path.startsWith('/derslerim')) return <RequireTeacher>{(me, refresh) => <LessonsPage me={me} onChange={refresh} />}</RequireTeacher>;
  if (path.startsWith('/ogrencilerim')) return <RequireTeacher>{(me) => <StudentsPage me={me} />}</RequireTeacher>;
  if (path.startsWith('/profil')) return <RequireTeacher>{(me, refresh) => <ProfilePage me={me} onChange={refresh} />}</RequireTeacher>;
  if (path.startsWith('/yonetim')) return <Admin />;
  if (path.startsWith('/giris')) return <Login />;
  if (path.startsWith('/kayit')) return <Register />;
  if (path.startsWith('/sifremi-unuttum')) return <ForgotPassword />;
  if (path.startsWith('/sifre-sifirla')) return <ResetPassword />;
  if (path.startsWith('/e-posta-dogrula')) return <VerifyEmail />;
  const legal = path.replace(/\//g, '');
  if (legal) return <Legal kind={legal as LegalKind} />;
  return <Home />;
}
